<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { whatsappLink, trackConversion } from '@/lib/whatsapp'
import WhatsappIcon from '@/components/WhatsappIcon.vue'

const props = defineProps({
  phone: { type: String, required: true }
})

// It shows up only past the hero: there is already a button up there, and
// covering it with a second one is just nagging. On desktop it stays hidden —
// the sticky header keeps its own quote button in view, and a floating pill
// there only lands on top of the copy.
const visible = ref(false)
const href = computed(() => whatsappLink(props.phone, 'cortinas a medida'))

function onScroll () {
  visible.value = window.scrollY > window.innerHeight * 0.85
}

onMounted(() => {
  onScroll()
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => window.removeEventListener('scroll', onScroll))
</script>

<template>
  <Transition
    enter-active-class="transition duration-500 ease-soft"
    enter-from-class="opacity-0 translate-y-4"
    leave-active-class="transition duration-300 ease-soft"
    leave-to-class="opacity-0 translate-y-4"
  >
    <a
      v-show="visible"
      :href="href"
      target="_blank"
      rel="noopener"
      class="group fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full bg-glow py-3.5 pl-4 pr-5 text-night shadow-lg shadow-night/30 ring-1 ring-night/15 transition-colors duration-300 hover:bg-[#f4a62a] sm:bottom-8 sm:right-8 lg:hidden"
      @click="trackConversion('floating-bubble', 'cortinas a medida')"
    >
      <WhatsappIcon class="h-5 w-5 shrink-0" />
      <span class="text-sm font-semibold">Cotizar</span>
    </a>
  </Transition>
</template>
